import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, DollarSign, CheckCircle2, ArrowRight } from 'lucide-react';
const creditFeatures = ['Revision de reporte de credito', 'Estrategia de disputa personalizada', 'Plan de mejora de puntuacion y asesoramiento', 'Monitoreo continuo de credito y actualizacion'];
const fundingFeatures = ['Business Lines of Credit', 'Personal Lines of Credit', 'Personal Loans', 'Credit Card Stacking & more'];
export function Services() {
  return <section id="servicios" className="bg-black py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-223">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-224" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-226">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-227">
            Nuestros Servicios
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-228">
            Dos Pilares,{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-229">
              Un Solo Objetivo
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-230">
            Optimizamos tu credito y conseguimos el capital que necesitas, todo
            con un servicio completamente personalizado.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-231">
          {/* Service 01 — Credit */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-8 md:p-10 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border border-white/[0.08]" data-id="element-232">
            <div className="flex items-center gap-4 mb-8" data-id="element-233">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center" data-id="element-234">
                <TrendingUp className="h-7 w-7 text-amber-400" strokeWidth={2} data-id="element-235" />
              </div>
              <span className="text-sm font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-236">
                Servicio 01
              </span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-237">
              Optimizacion de{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-238">
                Credito
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-8" data-id="element-239">
              Revisamos tu reporte de credito y diseñamos una estrategia
              totalmente personalizada para ti, con el objetivo de optimizarlo y
              hacerlo atractivo para los bancos y demas instituciones
              financieras para conseguir capital.
            </p>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-240">
              {creditFeatures.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-241">
                  <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-242" />
                  <span className="text-white/70 font-light" data-id="element-243">{feature}</span>
                </li>)}
            </ul>

            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent group" data-id="element-244">
              Quiero optimizar mi credito
              <ArrowRight className="h-4 w-4 text-amber-400 group-hover:translate-x-1 transition-transform" data-id="element-245" />
            </a>
          </motion.div>

          {/* Service 02 — Funding (highlighted) */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-8 md:p-10 rounded-3xl bg-gradient-to-b from-amber-500/[0.06] to-transparent border border-amber-500/30 shadow-2xl shadow-amber-500/5" data-id="element-246">
            <div className="flex items-center gap-4 mb-8" data-id="element-247">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center" data-id="element-248">
                <DollarSign className="h-7 w-7 text-amber-400" strokeWidth={2} data-id="element-249" />
              </div>
              <span className="text-sm font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-250">
                Servicio 02
              </span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-251">
              Funding{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-252">
                Solutions
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-8" data-id="element-253">
              Luego de optimizar tu reporte de credito, diseñamos estrategias
              personalizadas para conseguir el capital que necesitas para
              emprender o impulsar tu negocio.
            </p>

            {/* Capital range highlight box */}
            <div className="rounded-2xl border border-amber-500/20 bg-black/40 p-6 mb-8" data-id="element-254">
              <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-3" data-id="element-255">
                Rango de Capital Disponible
              </div>
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-256">
                $50,000 a $100,000
              </div>
            </div>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-257">
              {fundingFeatures.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-258">
                  <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-259" />
                  <span className="text-white/70 font-light" data-id="element-260">{feature}</span>
                </li>)}
            </ul>

            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent group" data-id="element-261">
              Quiero acceder a financiamiento
              <ArrowRight className="h-4 w-4 text-amber-400 group-hover:translate-x-1 transition-transform" data-id="element-262" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}